// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * core-service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NewFpsTransferAPIModel
 */
export interface NewFpsTransferAPIModel {
    /**
     * 
     * @type {string}
     * @memberof NewFpsTransferAPIModel
     */
    messageId: string;
    /**
     * 
     * @type {string}
     * @memberof NewFpsTransferAPIModel
     */
    amount: string;
    /**
     * 
     * @type {number}
     * @memberof NewFpsTransferAPIModel
     */
    accountId: number;
    /**
     * 
     * @type {string}
     * @memberof NewFpsTransferAPIModel
     */
    createOnly?: string;
}

export function NewFpsTransferAPIModelFromJSON(json: any): NewFpsTransferAPIModel {
    return NewFpsTransferAPIModelFromJSONTyped(json, false);
}

export function NewFpsTransferAPIModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): NewFpsTransferAPIModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'messageId': json['messageId'],
        'amount': json['amount'],
        'accountId': json['accountId'],
        'createOnly': !exists(json, 'createOnly') ? undefined : json['createOnly'],
    };
}

export function NewFpsTransferAPIModelToJSON(value?: NewFpsTransferAPIModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'messageId': value.messageId,
        'amount': value.amount,
        'accountId': value.accountId,
        'createOnly': value.createOnly,
    };
}


